
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class LotCreationBOMDialog extends Common.GridEditorDialog<LotCreationBOMRow> { 
        //protected getIdProperty() { return LotCreationBOMRow.idProperty; }
        protected getLocalTextPrefix() { return LotCreationBOMRow.localTextPrefix; }
        //protected getNameProperty() { return LotCreationBOMRow.nameProperty; }
        //protected getService() { return LotCreationBOMService.baseUrl; } 

    }
}